import React from 'react';

import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import { LazyTravelProductToggleControl } from './TravelProductToggleControl.lazy';
import type { TravelProductToggleControlProps } from './TravelProductToggleControl';

const ConnectedTravelProductToggleInner: React.FC<TravelProductToggleControlProps> = props => {
  const [isProductToggleEnabled] = useIsFeatureEnabled('travelHotelCarProductToggle');

  if (!isProductToggleEnabled) {
    return null;
  }

  return <LazyTravelProductToggleControl {...props} />;
};

export const ConnectedTravelProductToggle = React.memo(ConnectedTravelProductToggleInner);
